import React, { useEffect } from 'react';
import { Spin } from 'antd';
import BankruptcyForm from './BankruptcyForm';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store';
import {
  bankruptcyStatesSelector,
  resultSelector,
} from './Bankruptcy.selectors';
import { getStates as getStatesAction } from './Bankruptcy.actions';
import { BANKRUPTCY_FORM } from './Bankruptcy.constants';
import { getFormValues } from 'redux-form';
import { LOADING, Sizes, loadingSelector, ReducerNames } from 'common';
import { getAccessToken } from 'common/helpers';
import { InteractionStatus } from '@azure/msal-browser';
import { useAccount, useMsal } from '@azure/msal-react';

const Bankruptcy: React.FC = () => {
  const dispatch = useDispatch();
  const { bankruptcyStates, loading, formValues } = useSelector(
    (state: AppState) => ({
      bankruptcyStates: bankruptcyStatesSelector(state),
      loading: loadingSelector(ReducerNames.BANKRUPTCY)(state),
      result: resultSelector(state),
      formValues: getFormValues(BANKRUPTCY_FORM)(state),
    }),
  );
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    if (account && inProgress === InteractionStatus.None && !bankruptcyStates) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(getStatesAction(response.accessToken));
      });
    }
  }, [dispatch, bankruptcyStates, instance, account, inProgress]);

  return (
    <Spin
      spinning={loading && !bankruptcyStates}
      size={Sizes.LARGE}
      tip={LOADING}
    >
      <BankruptcyForm
        {...{
          bankruptcyStates,
          loading,
          formValues,
        }}
      />
    </Spin>
  );
};

export default Bankruptcy;
